import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { CancelSubscriptionState, CreateSubscriptionV2State, GetActivePlansState, GetAdyenPaymentMethodsState, GetCouponDetailsState, GetPrimaryPaymentSourceState, GetSubscriptionItemsState, GetUserSubscriptionCreditNotesState, GetUserSubscriptionInvoicesState, GetUserSubscriptionsState, PrintSubscriptionCreditNoteState, PrintSubscriptionInvoiceState, SubscriptionState, UpdatePaymentSourceState, UpdateVehicleFromDOMState } from './Types';

import * as Actions from './Actions';
export type SubscriptionAction = ActionType<typeof Actions>;

const getActivePlansInitialState: GetActivePlansState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const getSubscriptionItemsInitialState: GetSubscriptionItemsState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const getUserSubscriptionsInitialState: GetUserSubscriptionsState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const getPrimaryPaymentSourceInitialState: GetPrimaryPaymentSourceState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const getUserSubscriptionInvoicesInitialState: GetUserSubscriptionInvoicesState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const getUserSubscriptionCreditNotesInitialState: GetUserSubscriptionCreditNotesState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const updatePaymentSourceInitialState: UpdatePaymentSourceState = {
    isCommunicating: false,
    data: false,
    error: false,
};

const getCouponDetailsInitialState: GetCouponDetailsState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const updateVehicleFromDOMInitialState: UpdateVehicleFromDOMState = {
    isCommunicating: false,
    error: false,
};

const createSubscriptionV2InitialState: CreateSubscriptionV2State = {
    isCommunicating: false,
    data: {
        status: 0,
        vehcode: -1,
        isDue: false,
        hasScheduledChanges: false,
    },
    error: false,
};

const cancelSubscriptionInitialState: CancelSubscriptionState = {
    isCommunicating: false,
    data: {
        status: 0,
        vehcode: -1,
        isDue: false,
        hasScheduledChanges: false,
    },
    error: false,
};

const printSubscriptionInvoiceInitialState: PrintSubscriptionInvoiceState = {
    isCommunicating: false,
    data: undefined,
    error: false,
};

const printSubscriptionCreditNoteInitialState: PrintSubscriptionCreditNoteState = {
    isCommunicating: false,
    data: undefined,
    error: false,
};

const getAdyenPaymentMethodsInitialState: GetAdyenPaymentMethodsState = {
    isCommunicating: false,
    data: {},
    error: false,
};

export default combineReducers<SubscriptionState, SubscriptionAction>({

    getActivePlans: (state = getActivePlansInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getActivePlansRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getActivePlansSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getActivePlansFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getSubscriptionItems: (state = getSubscriptionItemsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getSubscriptionItemsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getSubscriptionItemsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getSubscriptionItemsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getUserSubscriptions: (state = getUserSubscriptionsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getUserSubscriptionsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getUserSubscriptionsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getUserSubscriptionsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getPrimaryPaymentSource: (state = getPrimaryPaymentSourceInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getPrimaryPaymentSourceRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getPrimaryPaymentSourceSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getPrimaryPaymentSourceFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getUserSubscriptionInvoices: (state = getUserSubscriptionInvoicesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getUserSubscriptionInvoicesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getUserSubscriptionInvoicesSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getUserSubscriptionInvoicesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getUserSubscriptionCreditNotes: (state = getUserSubscriptionCreditNotesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getUserSubscriptionCreditNotesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getUserSubscriptionCreditNotesSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getUserSubscriptionCreditNotesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getCouponDetails: (state = getCouponDetailsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getCouponDetailsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getCouponDetailsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getCouponDetailsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    updateVehicleFromDOM: (state = updateVehicleFromDOMInitialState, action) => {
        switch (action.type) {
            case getType(Actions.updateVehicleFromDOMRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.updateVehicleFromDOMSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.updateVehicleFromDOMFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    updatePaymentSource: (state = updatePaymentSourceInitialState, action) => {
        switch (action.type) {
            case getType(Actions.updatePaymentSourceRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.updatePaymentSourceSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.updatePaymentSourceFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    createSubscriptionV2: (state = createSubscriptionV2InitialState, action) => {
        switch (action.type) {
            case getType(Actions.createSubscriptionV2Request):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.createSubscriptionV2Success):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.createSubscriptionV2Failure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    cancelSubscription: (state = cancelSubscriptionInitialState, action) => {
        switch (action.type) {
            case getType(Actions.cancelSubscriptionRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.cancelSubscriptionSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.cancelSubscriptionFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    printSubscriptionInvoice: (state = printSubscriptionInvoiceInitialState, action) => {
        switch (action.type) {
            case getType(Actions.printSubscriptionInvoiceRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.printSubscriptionInvoiceSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.printSubscriptionInvoiceFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    printSubscriptionCreditNote: (state = printSubscriptionCreditNoteInitialState, action) => {
        switch (action.type) {
            case getType(Actions.printSubscriptionCreditNoteRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.printSubscriptionCreditNoteSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.printSubscriptionCreditNoteFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    getAdyenPaymentMethods: (state = getAdyenPaymentMethodsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getAdyenPaymentMethodsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.getAdyenPaymentMethodsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getAdyenPaymentMethodsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },

});
